import classNames from 'classnames';
import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { WorkspaceTabOwnProps } from 'shared/connect/connect';
import { dynamicQuoteRemovedThunk } from 'state/dynamic/dynamicForm.thunks';
import { ThunkDispatch } from 'state/state.common';
import { staticQuoteRemovedThunk } from 'state/static/staticForm.thunks';
import { WorkspaceType } from 'state/workspaces/model';

interface DispatchProps {
  onDone?: () => void;
}
interface OwnProps {
  className?: string;
  workspace: WorkspaceType;
}

interface Props extends OwnProps, DispatchProps {}
export function ErrorReset({ className, workspace, onDone }: Props) {
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');
  const newUxSidePanelWhenQuoteRejectedParis = workspace === 'static' || workspace === 'dynamic';
  const legacySidePanelUxWhenQuoteRejectedParis = !newUxSidePanelWhenQuoteRejectedParis;

  return (
    <div className={classNames('d-flex mb-2', className)}>
      {legacySidePanelUxWhenQuoteRejectedParis ? (
        <button className="btn btn-xl  btn-discreet-secondary  w-50" onClick={onDone}>
          <FormattedMessage id="ok" />
        </button>
      ) : (
        <></>
      )}

      {helpCenterEnhancement ? (
        <div className={'d-flex w-100'}>
          <ConnectedHelpCenterButton helpCenterId={ErrorReset.name} />
        </div>
      ) : (
        <LifeRingTrigger e2e="SecondaryPanelContactUs-button" className={'d-flex w-100'}>
          <button type="button" className="btn btn-default btn-xl m-1 w-100">
            <FormattedMessage id="lifeRing.helpRequest" />
            <em className="icon icon-outlined ms-1">live_help</em>
          </button>
        </LifeRingTrigger>
      )}
    </div>
  );
}
const mapDispatchToProps = (dispatch: ThunkDispatch, { formId, workspace }: WorkspaceTabOwnProps): DispatchProps => {
  return {
    onDone() {
      if (workspace === 'static') {
        dispatch(staticQuoteRemovedThunk(formId));
      } else {
        dispatch(dynamicQuoteRemovedThunk(formId));
      }
    },
  };
};

export const ConnectedErrorReset = connect(undefined, mapDispatchToProps)(ErrorReset);
